// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".count[data-v-7e3f76af]{color:#b8ddbf;font-weight:400}.guests-wizard[data-v-7e3f76af]{margin-bottom:2em}.err-msg[data-v-7e3f76af]{margin-bottom:1rem}.disabled-search-button-text[data-v-7e3f76af],.err-msg[data-v-7e3f76af]{color:var(--colour-red);font-size:var(--body);text-align:center}.disabled-search-button-text[data-v-7e3f76af]{margin-bottom:.5em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
